import * as React from 'react';
import { Plus } from 'lucide-react';

import Modal from '../ui/Modal';
import CreateTeam from '../Teams/CreateTeam';

export default function CreateTeamDialog({ handleClickOpenTeamModal }) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        handleClickOpen()
        setOpen(false);
        handleClickOpenTeamModal()

    };

    return (
        <React.Fragment>
            <button
                onClick={handleClickOpen}
                className="w-full flex items-center justify-center gap-2 border-2 border-dashed border-neutral-300 rounded-xl py-4 mb-4 text-neutral-500 hover:border-seha-400 hover:text-seha-500 hover:bg-seha-50 transition-all dark:border-neutral-700 dark:text-neutral-500 dark:hover:bg-seha-500/10"
            >
                <Plus className="w-4 h-4" /> Add Team
            </button>

            <Modal
                open={open}
                onClose={handleClose}
                title="Add Team"
                size="xl"
                footer={null}
            >
                <CreateTeam />
            </Modal>
        </React.Fragment>
    );
}
